module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori-e774bb112ca72b3c30715f772c8c0a50.webp";